import { motion } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";

export const PageHero = ({ eyebrow, lines, text, image, testId }) => (
  <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44 lg:pb-24" data-testid={testId}>
    <div className="mx-auto grid max-w-7xl items-end gap-10 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-7">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} className="eyebrow">
          {eyebrow}
        </motion.p>
        <MaskedLines lines={lines} className="font-display mt-5 text-4xl font-bold leading-[0.98] sm:text-5xl lg:text-6xl" delay={0.1} />
        {text && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="mt-7 max-w-xl text-base leading-relaxed text-[var(--ink-2)] md:text-lg"
          >
            {text}
          </motion.p>
        )}
      </div>
      {image && (
        <motion.div
          initial={{ opacity: 0, scale: 0.96, clipPath: "inset(10% 10% 10% 10% round 24px)" }}
          animate={{ opacity: 1, scale: 1, clipPath: "inset(0% 0% 0% 0% round 24px)" }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="img-zoom relative aspect-[4/3] overflow-hidden rounded-3xl lg:col-span-5"
        >
          <img src={image} alt="" className="h-full w-full object-cover" />
        </motion.div>
      )}
    </div>
  </section>
);
